import {
  createEntityAdapter,
  createSlice,
  PayloadAction,
} from '@reduxjs/toolkit';
import { RootState } from 'src/store/index';

export type State = {
  loading: boolean;
};

export const adapter = createEntityAdapter<Model.UserPagerDocument>({
  selectId: (model) => model.id,
});

const { reducer, actions } = createSlice({
  name: 'pager_document',
  initialState: adapter.getInitialState<State>({ loading: false }),
  reducers: {
    updateEntities(state, action: PayloadAction<Model.UserPagerDocument[]>) {
      adapter.upsertMany(state, action);
    },
    updateEntity(state, action: PayloadAction<Model.UserPagerDocument>) {
      adapter.upsertOne(state, action);
    },
    removeEntity(state, action: PayloadAction<Model.UserPagerDocument>) {
      adapter.removeOne(state, action.payload.id);
    },
    updateLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
  },
});

export const selector = adapter.getSelectors(
  (state: RootState) => state.model.pager_document,
);

export { reducer };
export default actions;
